define('SageDotCom/DataLayer/Events/product-list-button',[
    "jquery",
    "SageDotCom/DataLayer/Events/eventBase"
], function ($, EventBase) {
    
    function ProductListButton(el, eventName) {
        EventBase.call(el);

        var sectionTitleHeader = $(el).parents(".container").prev(".container").first().find(".score-section-header h2")
            .text().trim();
        var sectionTitleContentSpot = $(el).parents(".container").prev(".container").first().find(".score-content-spot h1").text().trim();
        var sectionTitle = sectionTitleHeader ? sectionTitleHeader : sectionTitleContentSpot;
        var titleCard = $(el).parents(".score-highlight").find(".score-highlight-header").text().trim();
        var cardName = $(el).parents(".caption").find(".inner-heading").text().trim();
        var flexItemPosition = $(el).closest(".score-flex-box").children().index($(el).parents(".flex-item"));

        this.props = {
            "event_name" : eventName,
            "shop_list_name": sectionTitle, 
            "product_group_name": [titleCard], 
            "product_group_id": [cardName],
            "product_list_position": [flexItemPosition+1],
            "product_category": ["subscription"],
            "product_sub_category_l1": [],
            "product_sub_category_l2": []
        };
    }
        ProductListButton.prototype = Object.create(EventBase.prototype);

        return ProductListButton;
});
